module.exports = __webpack_public_path__ + "img/high-voltage.bcac9d73.svg";